import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { gridDetail, gridEditable, gridSimple, createGridConfig, gridMultiple, SettingGrid } from "./gridSettings/gridSettings";
import { DynamicSelectComponent } from "../../components/dynamic-select/dynamic-select.component";
import { movimentiRifiuto } from "./movimentiRifiuto";
import { N } from "@angular/cdk/keycodes";
const colonneSoggetto = [
  {
    dataField: 'ragioneSociale',
    dataType: 'string',
    caption: 'Ragione sociale',
    allowEditing: true,
    colWidth: '300',
  },
  {
    dataField: 'codiceFiscale',
    dataType: 'string',
    caption: 'Codice Fiscale',
    colWidth: '110',
    type: 'campo',
  },
  {
    dataField: 'partitaIva',
    dataType: 'string',
    colWidth: '110',
    caption: 'Partita Iva',

    type: 'campo',
  },
  {
    dataField: 'comune',
    colWidth: '240',
    caption: 'Località',
    type: 'campo',
    dataType: 'string',
  },
  {
    dataField: 'indirizzo',
    colWidth: '210',
    caption: 'Indirizzo',
    type: 'campo',
    dataType: 'string',
  },
]

const colonneSede = [
  /*  {
     dataField: 'tipoAttività',
     dataType: '',
     caption: '',
     allowEditing: true,
     colWidth: '60',
   }, */
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '200',
  },
  {
    dataField: 'comune',
    dataType: '',
    caption: 'Località',
    allowEditing: true,
    colWidth: '100',
  },
  {
    dataField: 'indirizzo',
    dataType: '',
    caption: 'Indirizzo',
    allowEditing: true,
    colWidth: '100',
  },
]

const colonneAlboCategoria = [
  {
    type: 'campoSpecial',
    editorType: 'dxSelectBox',
    dataField: "idCategoriaAlboGestore",
    caption: "Cat. Albo Gestore", dataType: "",
    colWidth: '50',
    lista: {
      dataSource: 'CategoriaAlboGestore',
      valueExpr: 'id',
      displayExpr: 'descrizione',
      static: false,
    }

  },
  { type: 'campoSpecial', dataField: "descrizione_Full", caption: "Classe Albo Gestore", dataType: "", },
  {
    type: 'campoData',
    dataField: "dataInizio",
    caption: "Data Inizio",
    format: "dd/MM/yyyy", editorType: "dxDateBox",
    dataType: "date",
    colWidth: '100',
  },

]

const generic = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: true,
    colWidth: '60'
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '540'
  },
]


const settingGridGeneric: SettingGrid = {
  masterKey: 'id',
  keyUnique: '',
  mode: null,
  selectionMode: 'single',
  remoteOperations: true,
  hoverStateEnabled: true,
  rowAlternationEnabled: true,
  repaintChangesOnly: true,
  showFilterSearch: false,
  allowUpdating: false,
  allowDeleting: false,
  allowAdding: false,
  height: 630,
  showColBlank: false,
  colonne: [
    {
      dataField: 'id',
      dataType: '',
      caption: 'Codice',
      allowEditing: true,
      colWidth: '60px'
    },
    {
      dataField: 'descrizione',
      dataType: '',
      caption: 'Descrizione',
      allowEditing: true,
      colWidth: '560px'
    },
  ],

}


const campiRicercaAutorizzazioneArea = [
  {
    itemType: "group", colCount: "3", class: "w-100", caption: "", data: [

      {
        type: 'campo',
        dataField: "descrizioneArea",
        caption: 'Descrizione',
        dataType: "text",
        colWidth: '100',
        colVisible: true,
      },

    ],
  }
]

const CausaleRifiuti = {
  type: 'campo', colVisible: true, dataField: "idCausale",
  dataType: "",
  nCol: 5,
  disableOnUpdate: true,
  caption: "Causale",
  editorType: '',
  odataType: 'select',
  odataFilter: 'contains',
  staticDataField: 'idCausale',
  dynamic: {
    dataSource: 'CausaleRifiuti',
    autocomplete: false,
    valueExpr: 'id',
    displayExpr: 'descrizione',
    caption: "Lista Causali",
    queryString: '?$filter=(isExistsPosizione eq true)',
    filter: '',
    related: ['id|descrizione'],
    componentType: 'dynamicGrid',
    buttonOption: {
      text: 'Causali',
      icon: 'glyphicon mdi mdi-playlist-plus',
      hint: 'Scelta della Causale',
      name: 'stoccaggio',
      location: 'after',

    },
    settingGrid: createGridConfig(
      {
        ...gridMultiple,
        isOdata: true,

        colonne: [
          {
            dataField: 'idTipoOperazione',
            dataType: '',
            caption: 'Tipo',
            colSpan: 3,
            allowEditing: false,
            groupIndex: 0,
            colWidth: '90',
            lista: {
              dataSource: 'TipoOperazioneCausaleRifiuti',
              valueExpr: 'id',
              displayExpr: 'descrizione',
              static: false,


            }
          },
          {
            dataField: 'idOperazione',
            dataType: '',
            caption: 'Op.',
            allowEditing: false,
            colWidth: '35'
          },
          {
            dataField: 'descrizione',
            dataType: '',
            caption: 'Descrizione',
            allowEditing: false,
            colWidth: '365'
          },
        ]
      })
  }
}

const PosizioneRifiuti = {
  type: 'campo', colVisible: true, dataField: "idPosizioneRifiuto",
  dataType: "",
  nCol: 5,
  labelWidth: 64,
  disableOnUpdate: true,
  caption: "Posizione",
  editorType: '',
  odataType: 'select',
  odataFilter: 'contains',
  staticDataField: 'idPosizioneRifiuto',
  dynamic: {
    dataSource: 'PosizioneRifiuti',
    autocomplete: false,
    valueExpr: 'id',
    displayExpr: 'descrizione',
    caption: "Lista Posizioni",
    queryString: '',
    filter: '',
    componentType: 'dynamicGrid',
    buttonOption: {
      text: 'Posizioni',
      icon: 'glyphicon mdi mdi-playlist-plus',
      hint: 'Scegli la posizione',
      name: 'stoccaggio',
      location: 'after',

    },
    settingGrid: createGridConfig(
      {
        ...gridMultiple,
        isOdata: true,
        colonne: [

          {
            dataField: 'descrizione',
            dataType: '',
            caption: 'Descrizione',
            colWidth: 530,
            allowEditing: true,
          },
        ]
      })
  }

}

const campiRicercaAutorizzazioneSoggetti = [
  {
    itemType: "group", colCount: "3", class: "w-100", caption: "", data: [

      {
        type: 'campo',
        dataField: "descrizione",
        caption: 'Descrizione',
        dataType: "text",
        colWidth: '100',
        colVisible: true,
      },
      {
        type: 'campo',
        dataField: "numero",
        caption: "Numero",
        colWidth: '91',
        colVisible: true,
        dataType: "text",
      },
      {
        type: 'campo',
        dataField: "dataRilascio",
        caption: "Data Rilascio",
        colWidth: '91',
        colVisible: true,
        dataType: "date",

      },
    ],
  }
]

const empty = { type: 'empty', dataField: '', dataType: '' }
const divider = { type: 'empty', dataField: '', dataType: '', caption: ' ', colSpan: 4 }
const protocollo = {
  type: 'campo', dataType: '', dataField: 'protocollo', caption: 'Protocollo',
  colVisible: true, maxLength: '6', colWidth: '102', orderGriglia: 3, nCol: 25,
  odataType: 'string',
  odataFilter: 'contains',
  staticDataField: 'protocollo',
}

const numDocumentoInterno = {
  type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.docum.',
  colVisible: true, maxLength: '15', nCol: 25, labelWidth: 90,
  odataType: 'string',
  odataFilter: 'contains',
  staticDataField: 'numDocumentoInterno',
}
const riferimentoDocumento = {
  type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Rif.docum.',
  colVisible: true, nCol: 25,
  maxLength: '15',
  odataType: 'string',
  odataFilter: 'contains',
  staticDataField: 'riferimentoDocumento',

}
const numeroFormulario = {
  type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.Fir',
  maxLength: '20', maxSize: 20, nCol: 35, labelWidth: 65,
  colVisible: true,
  odataType: 'string',
  odataFilter: 'contains',
  staticDataField: 'numeroFormulario',
}

const scontrino = {
  type: 'campo', dataField: "scontrino", dataType: "", caption: "Scontrino",
  width: '100',
  maxLength: "10",
  colVisible: false,
  colWidth: '100',
  nCol: 25,
  labelVisible: true,
  // odataType: 'string',
  // odataFilter: 'contains',
  // staticDataField: 'scontrino',

}

const idBasilea = {
  type: 'campoSpecial', colVisible: true, dataField: "idBasilea",
  labelWidth: 90,
  nCol: 5,
  width: 37,
  maxLength: '5',
  caption: "Reg.1013",
  editorClass: 'text-uppercase',
  odataType: 'select',
  odataFilter: '=',
  staticDataField: 'idBasilea',
  dynamic: {
    valueExpr: 'id',
    queryString: '',
    displayExpr: '',
    service: '',
    dataSource: 'Basilea',
    componentType: 'dynamicGrid',
    autocomplete: false,
    settingGrid: settingGridGeneric,
    buttonOption: {
      text: 'categorie',
      icon: 'glyphicon mdi mdi-playlist-plus',
      hint: 'Lista dei Cer Basilea',
      name: 'categorie',
      location: 'after',
    }
  },
}

const idRecup = {
  type: 'campoSpecial',
  dataField: "idRecup",
  caption: "Tip.DM 5/2/98",
  width: 37,
  nCol: 5,
  dataType: "",
  maxLength: '8',
  colVisible: false,
  labelWidth: 90,
  odataType: 'select',
  odataFilter: '=',
  staticDataField: 'idRecup',
  dynamic: {
    valueExpr: '',
    queryString: "",
    displayExpr: 'codice',
    service: '',

    dataSource: 'Recup',
    componentType: 'dynamicGrid',
    autocomplete: false,
    settingGrid: createGridConfig({

      ...gridSimple,
      width: 500,
      colonne: [
        {
          dataField: 'codice',
          dataType: 'string',
          caption: 'Codice',
          allowEditing: true,
          colWidth: '90',
        },
        {
          dataField: 'descrizione',
          dataType: 'string',
          caption: 'Descrizione',
          colWidth: '350',
          type: 'campo',
        },
      ]
    }),


    buttonOption: {
      text: 'Recup',
      icon: 'glyphicon mdi mdi-playlist-plus',
      hint: 'Lista elenco codici di recupero',
      name: 'Recup',
      location: 'after',
    },

  },
}

const quantitaKg = {
  type: 'campo', dataField: "quantitaKg", dataType: "number", caption: "Peso netto Kg",
  colAlignment: 'right',
  colCaption: 'Peso',
  width: '100',
  orderGriglia: 11,
  odataType: 'number',
  odataFilter: '=',
  staticDataField: 'quantitaKg',
  nCol: 35,
  colSpan: 5,
  maxLength: "8",
  colVisible: true,
  colWidth: '112',
  labelVisible: true,
  editorType: 'dxNumberBox',
  class: '',

}

let movimentiRifiutoMd = JSON.parse(JSON.stringify(movimentiRifiuto));

movimentiRifiutoMd = movimentiRifiutoMd.filter((resCol, z) => {
  let colSpanG = 0
  if (z == 1) {
    resCol.colGroup = 55;
    colSpanG = resCol.colCount
  }

  if (z == 2) {
    resCol.colGroup = 45;
    colSpanG = resCol.colCount
  }

  if (typeof resCol.data !== 'undefined') {
    const newData = []; // Nuovo array per contenere i dati con l'aggiunta

    resCol.data.forEach(d => {
      delete d.validation;
      if (d.type == 'empty' && d.colSpan == colSpanG && d.caption == ' ') {
        d.dataField = 'emptyno'
      }

      switch (d.dataField) {
        case 'causale_Descrizione':
          d = null
          newData.push(CausaleRifiuti)
          break
        case 'movimentiRegistro':
          d = null
          break
        case 'posizioneRifiuto_Descrizione':
          d = null
          newData.push(PosizioneRifiuti)
          break
        case 'produttore_Descrizione_Soggetto':
        case 'trasportatore_Descrizione_Soggetto':
        case 'destinatario_Descrizione_Soggetto':
        case 'intermediario_Descrizione_Soggetto':
          divider['colSpan'] = 4;
          d.showClearButton = true;
          d.dynamic.queryString = d.dynamic.queryString.replace('NostreAziende=N&', '')
          newData.push(divider);

          break
        case 'produttore_Descrizione_Sede':
        case 'trasportatore_Descrizione_Sede':
        case 'intermediario_Descrizione_Sede':
          d.nCol = 5
          d.showClearButton = true;

          //d.dynamic.related = []
          break
        case 'emptyno':
          d = null
          //newData.push()
          break;
        case 'dataRegistrazione':
          d.caption = 'Da Data';
          d.nCol = 25
          break;
        case 'dataFormulario':
          d.caption = 'A Data';
          d.nCol = 25
          d.labelWidth = 90;
          break;
        case 'oraRegistrazione':
        case 'dataDocumentoInterno':
          d.visible = false;
          break;
        case 'numeroFormulario':
          d = null
          empty['nCol'] = 15
          newData.push(empty)
          newData.push(numeroFormulario)

          // Aggiungi il nuovo elemento subito dopo 'numeroFormulario'

          newData.push(protocollo);
          newData.push(numDocumentoInterno);
          newData.push(scontrino)
          newData.push(riferimentoDocumento);


          // empty['colSpan']= 4
          newData.push(divider)

          break;
        case 'riferimentoDocumento':
          d.visible = false
          break;
        case 'numDocumentoInterno':
          d.visible = false
          break;
        case 'eer':
          d.dynamic.buttons = [];
          d.nCol = 35;
          break;
        case 'riferimentoEER':

          d.nCol = 25;
          break;
        case 'lotto_Descrizione':
          d = null;
          empty['nCol'] = 'auto'
          newData.push(empty);
          newData.push(quantitaKg);

          newData.push(idBasilea);
          newData.push(idRecup);
          newData.push(empty);
          newData.push(empty);
          newData.push(empty);
          newData.push(empty);
          newData.push(empty);

          newData.push(divider)
          newData.push(empty);
          newData.push(empty);
          break;
        case 'idStatoFisico':
          d.nCol = 2;
        case 'isUrbano':
          d.nCol = 15;

          break;
        case 'scontrino':
          d.visible = false;
          break;
        case "isDetentore":
          d.class = 'visually-hidden';
          break;
        case 'dataInizioTrasporto':
          d.caption = 'Da Fine trasp.';
          d.nCol = 35;
          d.labelWidth = 90;
          d.width = 100
          d.disabled = false;
          d.disableOnUpdate = false;
          // d.dataField = 'daDataFineTrasporto';
          // d.odataType= 'data';
          // d.odataFilter= 'le';
          // d.staticDataField= 'dataFineTrasporto';
          break;
        case 'dataFineTrasporto':
          d.caption = 'A';
          d.nCol = 25;
          d.width = 100;
          d.labelWidth = 23;
          d.disabled = false;
          d.disableOnUpdate = false;
          // d.dataField = 'aDataFineTrasporto';

          break;
        case 'categoriaDocumento_Descrizione':
        case 'tipoDocumento_Descrizione':
        case 'zonaDocumento_Descrizione':
        case 'bacinoDocumento_Descrizione':
          d.nCol = 10;
          d.colSpan = 5;
          d.labelWidth = 90;
          d.dynamic.settingGrid = gridMultiple
          break;
        case 'addElencoProduttori':
        case 'addElencoVettori':
        case 'addElencoIntermediari':
          empty['nCol'] = 'auto'
          d = empty;

          break
        case 'trasportoDesc':
        case 'listaHP':
        case 'oraInizioTrasporto':
        case 'oraFineTrasporto':
        case 'addDatiRifiuto':
        case 'eeR_Descrizione':

        case 'altriDatiFormulario':
        case 'datiPesata':
        case 'testoADR_Descrizione':
        case 'idClasseAdr':
        case 'idONU':
        case 'numeroColli':
        case 'annotazioni':
        case 'imballo_Descrizione':
        case 'quantitaOrigineKg':
        case 'verificatoPartenza':
        case 'volume':
        case 'descrizioneAssegnata':
        case 'unitaMisuraVolume':
        case 'caratteristicheChimiche':
        case 'quantitaRespinta':
        case 'tipoAccettazione':
        case 'idMotivoRespinta':
        case 'descrizioneRespinta':
        case "addDatiRitiri":
        case 'copiaComeNuovo':
        case 'adr':
        case 'quantitaKg':
          d = null;
          break;

        default:
          delete d.validation;
          break;
      }
      if (d) {
        newData.push(d); // Aggiungi l'elemento corrente a newData
      }
    });

    resCol.data = newData; // Assegna il nuovo array di dati modificati a resCol.data
    return true; // Restituisci true per mantenere resCol nell'array filtrato
  }

  return false; // Se resCol.data non è definito, restituisci false per escludere resCol dall'array filtrato
});

console.log('movimentiRifiutoMd--->', movimentiRifiutoMd);




export const movimentiRifiutoFiltri2: AnaColumn[] = movimentiRifiutoMd


export const movimentiRifiutoFiltri: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Filtri Avanzati',
      titleForm: '$filtriavanzati',
      breadcrumbCaption: 'Filtri Avanzati',
      campoTitle: ['filtriAvanzati'],
      masterKey: 'id',
      service: 'nomeTemplate',
      api: 'nomeTemplate',
      filterList: '?NomeTabella=$NomeTabella&IdTabella=$IdTabella',
      helpDoc: '#',
      queryFilter: [],
      filterEditor: '/$',
      formType: 'simple',
      idTabRif: [],
      nCol: 2,


    }

  },

  {
    itemType: "group", caption: "", colCount: "2", class: 'w-100 mt-4 mb-4', data: [

      {
        type: 'campo',
        colVisible: true,
        dataField: "causale_Descrizione",
        dataType: "",
        nCol: 5,
        disableOnUpdate: true,

        caption: "Causale ",
        labelWidth: 115,
        editorType: '',
        dynamic: {
          dataSource: 'CausaleRifiuti',
          autocomplete: false,
          valueExpr: '',

          displayExpr: 'descrizione',
          caption: "Lista Causali",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Causali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,

              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }
      },

      {
        type: 'campo', colVisible: true, dataField: "posizioneRifiuto_Descrizione",
        dataType: "",
        nCol: 5,
        disableOnUpdate: true,

        caption: "Posizione",
        labelWidth: 120,
        editorType: '',
        dynamic: {
          dataSource: 'PosizioneRifiuti',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Causali",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Causali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridMultiple,
              isOdata: false,
              colonne: [
                {
                  dataField: 'id',
                  dataType: '',
                  caption: 'OP.',
                  colWidth: 50,
                  allowEditing: true,
                },
                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]
            })
        }

      },


    ]
  },
  {
    itemType: "group", caption: "Dati generali documento e rifiuto", colCount: "5", class: 'w-100 mt-4 mb-4', data: [ // colSpan: "2"

      {
        type: 'campoData', dataType: 'date', dataField: 'daDataRegistrazione',
        caption: 'Da Data Registr.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        labelWidth: 120,
        nCol: 2,

        odataFilter: '>=',
        odataType: 'string',
        staticDataField: 'dataRegistrazione'
      },
      {
        odataFilter: '<=',
        odataType: 'string',
        staticDataField: 'dataRegistrazione',

        type: 'campoData',
        dataType: 'datetime',
        dataField: 'aDataRegistrazione',
        caption: 'A Data Registr.',
        colVisible: true,
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        nCol: 2,
        hideOnEdit: false,
        labelWidth: 120,
      },
      {
        type: 'campo', dataType: '', dataField: 'numDocumentoInterno', caption: 'N.docum.',
        colVisible: true, maxLength: '15', labelWidth: 125, nCol: 2,
      },
      {
        type: 'campo', dataType: '', dataField: 'riferimentoDocumento', caption: 'Rif.docum.',
        colVisible: true,
        maxLength: '15',
        labelWidth: 121,
        nCol: 2,
      },
      {
        type: 'campo', dataType: '', dataField: 'scontrino', caption: 'Scontrino',
        colVisible: true, maxLength: '10', labelWidth: 120, nCol: 2,
      },


      {
        type: 'campo', dataType: '', dataField: 'numeroFormulario', caption: 'N.Formulario',
        maxLength: '20', maxSize: 20, labelWidth: 120, nCol: 2,
        colVisible: true
      },

      /*
      {
        type: 'campo', dataType: '', dataField: 'peso', caption: 'Peso Netto',
        maxLength: '6', width: 9 + 'vw',
        editorType:'dxNumberBox',hideOnEdit:false,
        //defaultValue:0,
        colVisible: true
      },
      */

      {
        type: 'campo', dataType: 'number', dataField: 'minquantitaKg', caption: 'Peso Minimo',
        maxLength: '6',
        editorType: 'dxNumberBox',
        hideOnEdit: false,
        colVisible: true,
        min: 1,
        nCol: 2,
        labelWidth: 119,
      },
      {
        type: 'campo', dataType: 'number', dataField: 'maxquantitaKg', caption: 'Peso Massimo',
        maxLength: '6',
        editorType: 'dxNumberBox', hideOnEdit: false,
        colVisible: true, min: 1,
        labelWidth: 125,
        nCol: 2,
      },

      /***CER***/

      {
        type: 'campoSpecial', colVisible: true, dataField: "eer",

        maxLength: '6',
        caption: "EER.",
        nCol: 2,
        labelWidth: 120,
        editorType: 'dxAutocomplete',
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'generic',
          autocomplete: false,
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'descrizione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Stato Fisico',
            name: 'descrizione',
            location: 'after',
          },
          settingGrid: gridSimple,

        },

      },
      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "Stato Fisico",

        colVisible: false,
        labelVisible: true,
        labelWidth: 120,
        nCol: 2,
        showClearButton: false,
        maxLength: '2',
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple,

        },
      },

      {
        type: 'campoSpecial', colVisible: false, dataField: "idTipodocumento",
        maxLength: '10',
        caption: "Tipo doc.",
        editorType: 'dxSelectBox',
        labelWidth: 122,
        nCol: 2,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: 'descrizione',
          queryString: '?nomeTabella=soggetti',
          displayExpr: 'id',
          dataSource: 'Tipo',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Documenti",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'descrizione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Documenti',
            name: 'descrizione',
            location: 'after',
          },
          settingGrid: gridSimple,

        },

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idCategoriaDocumento",
        disableOnUpdate: true,
        maxLength: '10',
        caption: "Categ. doc.",
        labelWidth: 121,
        editorType: 'dxSelectBox',
        nCol: 2,
        dynamic: {
          valueExpr: 'id',
          queryString: '?nomeTabella=soggetti',
          displayExpr: 'descrizione',
          dataSource: 'Categoria',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Categorie",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'descrizione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Categorie',
            name: 'idCategoriaDocumento',
            location: 'after',
          },
          settingGrid: gridSimple,

        },

      },
      {

        type: 'campo',
        dataField: "daDataIniziotrasporto",
        caption: "Inizio Trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date", //datetime
        maxLength: '15',
        nCol: 2,
        labelWidth: 125,
        colVisible: false,

      },
      {

        type: 'campo',
        dataField: "aDataFinetrasporto",
        caption: "Fine Trasp.",
        format: "dd/MM/yyyy",
        editorType: "dxDateBox",
        dataType: "date", //datetime
        maxLength: '15',
        labelWidth: 120,
        nCol: 2,
        colVisible: false,

      },

      {

        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.EER.",
        colVisible: false,
        labelVisible: true,
        maxLength: '10',
        labelWidth: 122,
        nCol: 2,

      },

      {

        type: 'campoSpecial', colVisible: false, dataField: "zonaDocumento_Descrizione",



        caption: "Zona racc.",
        labelWidth: 123,
        editorType: 'dxSelectBox',
        nCol: 2,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: '?nomeTabella=soggetti',
          displayExpr: 'descrizione',
          dataSource: 'Zona',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Zone",
          componentType: 'dynamicGrid',
          related: ['id|idZonaDocumento'],
          buttonOption: {
            text: 'descrizione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Zone',
            name: 'descrizione',
            location: 'after',
          },
          settingGrid: gridSimple,

        },

      },
      {

        type: 'campoSpecial',
        colVisible: false,
        dataField: "recup_Descrizione",
        dataType: "",
        nCol: 4,
        labelWidth: 120,
        disableOnUpdate: true,
        caption: "Recupero",

        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: 'Recup',
          service: '',
          autocomplete: false,
          caption: "Lista Recupera",
          componentType: 'dynamicGrid',
          related: ['codice|idRecup'],
          buttonOption: {
            text: 'descrizione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Recupero',
            name: 'descrizione',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 500,
            colonne: [
              {
                dataField: 'codice',
                dataType: 'string',
                caption: 'Codice',
                allowEditing: true,
                colWidth: '90',
              },
              {
                dataField: 'descrizione',
                dataType: 'string',
                caption: 'Descrizione',
                colWidth: '350',
                type: 'campo',
              },
            ]
          }),

        },

      },
      /*
      {
        type: 'campo',
        dataField: 'isAvvenutoSmaltimento',
        dataType: "boolean",
        editorType: 'dxCheckBox',
        
        nCol: 2,
        caption: 'Avvenuto Smalt.',
        disabled: true,
        hideOnEdit: false,
        labelWidth: 130,
      },
    */
      { type: 'empty', dataField: '', dataType: '' },
    ]
  },
  {
    itemType: "group", caption: "Produttore", colCount: "2", data: [
      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "produttore_Descrizione_Full",
        disableOnUpdate: true,
        caption: "Produttore",
        labelWidth: 118,
        nCol: 10,
        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          queryString: '?TipoAttivita=P',
          filterStatic: '',
          displayExpr: 'descrizioneSede',
          autocomplete: true,
          searchExpr: 'descrizioneSoggetto',
          caption: "Elenco nostre unità produttive con attività di produzione",
          filter: '',
          related: ['id|idProduttore'],
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [
                {
                  dataField: 'descrizioneSoggetto',
                  dataType: '',
                  caption: 'Azienda',
                  groupIndex: 0,
                  colSpan: '2',
                  colWidth: '800',
                  hideOnEdit: false
                },

                {
                  dataField: 'descrizioneSede',
                  dataType: '',
                  caption: 'Unità Locale',
                  hideOnEdit: false,
                  colWidth: '700',
                },

              ]
            })



        },


      },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', colVisible: false, dataField: "autorizzazioneProduttore_Descrizione_Full",
        disableOnUpdate: true,
        caption: "Autorizz.",
        nCol: 5,
        labelWidth: 118,
        dynamic: {
          queryString: "/$idProduttore",
          filterStatic: "",
          displayExpr: 'numero',
          dataSource: "Autorizzazione",
          service: "autorizzazione",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneProduttore'],
          },
          autocomplete: false,
          valueExpr: '',
          related: ['id|idAutorizzazioneProduttore', 'numeroIscrizioneAlbo|produttoreNumeroIscrizioneAlbo'],
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },
            {
              key: 'descrizioneSoggetto',
              value: 'produttore_Descrizione_Soggetto'
            },
            {
              key: 'descrizioneSede',
              value: 'produttore_Descrizione_Sede'
            }

          ],

          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle autorizzazioni del soggetto selezionato',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid: createGridConfig({
            ...gridSimple,
            isOdata: false,
            colonne: campiRicercaAutorizzazioneSoggetti,
          })
        }


      },
      {
        type: 'campoSpecial', dataField: "magazzinoProduttore_Descrizione",
        dataType: "",
        caption: "Magazzino",
        nCol: 5,
        colVisible: true,
        disableOnUpdate: true,
        labelVisible: true,


        labelWidth: 80,
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          related: ['id|idMagazzinoProduttore'],
          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: '',
          caption: "Lista Magazzini produttore",
          queryString: '?idSede=$idProduttore',
          buttonOption: {
            text: 'magazzinoProduttore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzino  del soggetto selezionato',
            name: 'magazzinoProduttore',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 800,
            colonne: [
              {
                type: 'campo',
                dataField: "descrizione",
                caption: 'Magazzino',
                dataType: "text",
                colWidth: '100',
                colVisible: true,
              },
            ],
            isOdata: false
          }),
        }


      },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "cantiere_Descrizione", dataType: "", caption: "Cantiere",

        colVisible: false,
        labelVisible: true,
        hideOnEdit: false,
        disableOnUpdate: true,
        editorClass: 'text-uppercase',
        labelWidth: 118,
        nCol: '5',
        dynamic: {
          costantValue: [
            {
              key: 'idProduttore',
              value: 'idProduttore'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idProduttore",
          displayExpr: 'descrizione',
          dataSource: "Cantiere",
          service: 'cantiere',
          autocomplete: false,
          valueExpr: '',
          caption: "Lista Cantieri fuiri unità locale",
          related: ['id|idCantiereFuoriUl'],
          buttonOption: {
            text: 'CantiereFuoriUl',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista dei fuori unità locale del soggetto selezionato',
            name: 'CantiereFuoriUl',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 1000,
            colonne: colonneSede
          }),

        }
      },
    ]
  },
  {
    itemType: "group", caption: "Trasportatore", colCount: "2", data: [

      {
        labelWidth: 120,
        type: 'campoSpecial',
        colVisible: false,
        dataField: "trasportatore_Descrizione_Full",
        editorType: 'dxLookup',
        nCol: 10,
        disableOnUpdate: true,
        caption: "Trasportatore",
        dynamic: {
          dataSource: 'Sede/GetSediNsAziende',
          service: '',
          valueExpr: '',
          related: ['id|idTrasportatore', 'idSoggetto|idRimorchio', 'idSoggetto|idAutista'],
          queryString: '?TipoAttivita=T',
          displayExpr: ['descrizioneSoggetto', 'descrizioneSede'],
          autocomplete: false,
          caption: "Elenco nostre unità produttive con attività di trasporto",
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Unità locali',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Unità Locali',
            name: 'ul',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [
                {
                  dataField: 'descrizioneSoggetto',
                  dataType: '',
                  caption: 'Azienda',
                  groupIndex: 0,
                  colSpan: '2',
                  colWidth: '800',
                  hideOnEdit: false
                },

                {
                  dataField: 'descrizioneSede',
                  dataType: '',
                  caption: 'Unità Locale',
                  hideOnEdit: false,
                  colWidth: '700',
                },

              ]
            })
        },


      },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "autorizzazioneTrasportatoreAlbo_Full", dataType: "", caption: "Iscriz.Albo ",
        nCol: 5,
        labelWidth: 120,
        disableOnUpdate: true,
        colVisible: false,
        labelVisible: true,

        dynamic: {

          valueExpr: '',

          queryString: '/$idTrasportatore',
          displayExpr: 'descrizione_Full',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,

          caption: "Lista categoria albo del trasportatore selezionato",
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',

          related: ['id|idTrasportatoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreTras'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista iscrizione albo del trasportatore selezionato',
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              isOdata: false
            }),
        }


      },
      {
        type: 'campoSpecial',
        dataField: "idTrasportatoreAlboCategoria",
        labelWidth: 118,
        nCol: 5,
        disableOnUpdate: true,
        caption: "Categ. albo",
        colVisible: false,
        labelVisible: true,

        dynamic: {

          valueExpr: '',

          queryString: '/$idTrasportatore',
          displayExpr: 'descrizione_Full',
          dataSource: 'AlboCategoria',
          service: 'AlboCategoria',
          autocomplete: false,

          caption: "Lista categoria albo del trasportatore selezionato",
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',

          related: ['id|idTrasportatoreAlboCategoria', 'dataInizio|dataInizioCategoriaAlboGestoreTras', 'idCategoriaAlboGestore|idCategoriaAlboGestoreT'],
          buttonOption: {
            text: 'Albo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista iscrizione albo del trasportatore selezionato',
            name: 'albo',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              isOdata: false
            }),
        }


      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "automezzo_Targa",
        editorType: 'dxSelectBox',
        labelWidth: 122,
        caption: "Targa Automezzo",
        nCol: 5,
        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: "/$idTrasportatore?$filter=( tipoautomezzo ne 'D' )",
          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: false,
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),
        }



      },

      /**Rimorchio***/
      {
        type: 'campoSpecial', colVisible: false, dataField: "Rimorchio",
        editorType: 'dxSelectBox',
        labelWidth: 115,
        caption: "Targa Rimorchio",
        nCol: 5,

        disableOnUpdate: true,
        dynamic: {
          valueExpr: '',
          queryString: "/?$filter=tipoAutomezzo in ('D','E','F')",
          displayExpr: 'targa',
          dataSource: 'Automezzo',
          service: 'automezzo',
          autocomplete: false,
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice'],
          buttonOption: {
            text: 'Automezzo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Automezzi',
            name: 'Automezzo',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "descrizione",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),
        }


      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "autista_Descrizione_Full", labelVisible: true,
        editorType: 'dxSelectBox',
        nCol: 5,
        labelWidth: 120,
        caption: "Matricola Autista",
        disableOnUpdate: true,

        dynamic: {
          valueExpr: '',
          queryString: '/$idTrasportatore',
          filterStatic: '?$filter=(isautista eq true)',
          displayExpr: 'matricola',
          dataSource: 'Autista',
          service: 'autista',
          autocomplete: false,
          costantValue: [
            {
              key: 'idTrasportatore',
              value: 'idTrasportatore'
            },


          ],
          componentType: 'dynamicGrid',
          related: ['id|idAutomezzo', 'isScarrabile|isScarrabileMostrice', 'id|idAutista'],
          buttonOption: {
            text: 'Autista',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Autista',
            name: 'Autista',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridSimple,
            width: 600,
            colonne: [
              {
                type: 'campo', dataField: "targa", caption: "Nr. Targa",
                colWidth: 100
              },
              {
                type: 'campo', dataField: "matricola",
                caption: "Descrizione", colWidth: 500
              },


            ]
          }),
        }

      },
      { type: 'empty', dataField: '', dataType: '' },
      { type: 'empty', dataField: '', dataType: '' },
    ]
  },
  {
    itemType: "group", caption: "Destinatario", colCount: "2", data: [
      {
        type: 'campoSpecial', dataField: "destinatario_Descrizione_Soggetto", dataType: "", caption: "Destinatario",
        nCol: '10',

        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',

        disableOnUpdate: true,
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: true,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?NostreAziende=N&TipoAttivita=S',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|destinatario_Id_Soggetto', 'descrizione|destinatario_Descrizione_Sede', 'id|idDestinatario'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=((isDestinatario eq true) or (isSmaltitore eq true))',

          }

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatario_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        width: '100',
        nCol: '5',
        disableOnUpdate: true,
        /* placeHolder: 'Digita il Numero dell\'autorizzazione', */
        dynamic: {
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idDestinatario",
          filterStatic: "",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneDestinatario'],


          },

          dataSource: "Autorizzazione",
          service: 'autorizzazione',
          displayExpr: 'numero',
          autocomplete: true,
          valueExpr: '',
          related: ['id|idAutorizzazioneDestinatario'],
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle autorizzazioni del soggetto selezionato',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneSoggetti,
              isOdata: false
            }),

        }
      },
      {
        type: 'campoSpecial', dataField: "magazzinoDestinatario_Descrizione", dataType: "", caption: "Magaz.",

        nCol: '5',
        labelWidth: 55,
        colVisible: false,
        labelVisible: true,
        class: 'label-magazzino label-disabled',
        /* placeHolder: 'Digita il nome del magazzino..', */
        disableOnUpdate: true,
        dynamic: {

          queryString: "?idSede=$idDestinatario",
          filterStatic: "",

          displayExpr: 'descrizione',
          dataSource: "MagazzinoRifiuti",
          service: 'magazzinorifiuti',
          autocomplete: true,
          valueExpr: '',
          caption: "Lista Magazzini unità locale",
          related: ['id|idMagazzinoDestinatario'],
          searchOptions: {
            service: 'magazzinorifiuti',
            dataFieldToSearch: null,
            dataFielToDisplay: ['descrizione'],
            related: ['id|idMagazzinoDestinatario'],


          },

          buttonOption: {
            text: 'magazzinoDestinatario',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista magazzinoi del soggetto selezionato',
            name: 'magazzinoDestinatario',
            location: 'after',

          },
          costantValue: [
            {
              key: 'idDestinatario',
              value: 'idDestinatario'
            },

          ],
          componentType: 'dynamicGrid',
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 800,
              colonne: [
                {
                  type: 'campo',
                  dataField: "descrizione",
                  caption: 'Magazzino',
                  dataType: "text",
                  colWidth: '100',
                  colVisible: true,
                },
              ],
              isOdata: false
            }),

        }
      },

    ]
  },
  {
    itemType: "group", caption: "Intermedario", colCount: "2", data: [
      {
        type: 'campoSpecial', dataField: "intermediario_Descrizione_Soggetto", dataType: "", caption: "Intermediario",
        labelWidth: 118,
        nCol: '10',
        colVisible: false,
        labelVisible: true,
        editorClass: 'destinatario-desc',
        class: 'disabled-soggetti',
        disableOnUpdate: true,
        dynamic: {
          autocomplete: false,
          dataSource: "Soggetto",
          service: 'soggetto',
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Intermediario",
          queryString: '?NostreAziende=N&TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['idSoggetto|intermediario_Id_Soggetto', 'nsAzienda', 'descrizione|intermediario_Descrizione_Sede', 'id|idIntermediario'],

          buttonOption: {
            text: 'Soggetto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia intermediari',
            name: 'soggetto',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),
          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isIntermediario eq true)',

          }
        }

      },
      { type: 'empty', dataField: '', dataType: '' },

      {
        type: 'campoSpecial', dataField: "autorizzazioneDestinatario_Descrizione_Full",
        dataType: "",
        caption: "Autorizz.",
        colVisible: false,
        labelWidth: 120,
        nCol: '5',
        disableOnUpdate: true,
        /* placeHolder: 'Digita il Numero dell\'autorizzazione', */
        dynamic: {
          costantValue: [
            {
              key: 'idIntermediario',
              value: 'idIntermediario'
            },

          ],
          componentType: 'dynamicGrid',
          queryString: "/$idIntermediario",
          filterStatic: "",
          searchOptions: {
            dataFieldToSearch: campiRicercaAutorizzazioneSoggetti,
            dataFielToDisplay: ['descrizione', 'numero', 'dataRilascio'],
            related: ['id|idAutorizzazioneidIntermediario'],


          },

          dataSource: "Autorizzazione",
          service: 'autorizzazione',
          displayExpr: 'descrizione',
          autocomplete: true,
          valueExpr: '',
          related: ['id|idAutorizzazioneidIntermediario'],
          buttonOption: {
            text: 'Autorizzazione',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia la lista delle autorizzazioni del soggetto selezionato',
            name: 'autorizzazione',
            location: 'after',

          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              colonne: campiRicercaAutorizzazioneSoggetti,
              isOdata: false
            }),

        }
      },
      { type: 'empty', dataField: '', dataType: '' },
    ]
  }
]          